export default "__VITE_PUBLIC_ASSET__0f8aa658__"